import type { ModelConversationDetail, ModelConversationDetailMessage } from "~/services/conversation/dto/conversation.detail.dto";
import _ from 'lodash';

const findParentMessage = (totalList: ModelConversationDetailMessage[], resultList: ModelConversationDetailMessage[] = [], parentId: string | null) => {
  if (parentId === null) {
    return resultList;
  }
  const parentMessage = totalList.find(e => e.id === parentId);
  if (parentMessage) {
    resultList.push(parentMessage);
  }
  return findParentMessage(totalList, resultList, parentMessage?.parentId || null);
};
// const findChildMessage = (totalList: ModelConversationDetailMessage[], resultList: ModelConversationDetailMessage[] = [], childId: string | null) => {
//   if (!childId) {
//     return resultList;
//   }
//   const childList = _.orderBy(totalList.filter(e => e.parentId === childId), ['createdAt'], ['desc']);
//   console.log('findChildMessage', childList);
//   const childMessage = childList[0];
//   if (childMessage) {
//     resultList.push(childMessage);
//   }
//   return findChildMessage(totalList, resultList, childMessage?.id || null);
// };

export const initVersionConversationMessage = (data: ModelConversationDetail) => {
  let resultList: ModelConversationDetailMessage[] = [];
  const totalList = data.totalConversationMessageList || [];
  const lastMessage = totalList[totalList.length - 1];

  const parentList = findParentMessage(totalList, [], lastMessage.id);

  resultList = parentList.reverse();

  console.log('initVersionConversationMessage', resultList);

  data.conversationMessageList = resultList;

  return data
};

export const handleVersionConversationMessageList = (totalList: ModelConversationDetailMessage[] = [], message: ModelConversationDetailMessage, versionIndex: number) => {
  let resultList: ModelConversationDetailMessage[] = [];
  const messageVersion = totalList.find(e => e.parentId === message.parentId && e.versionPosition === versionIndex);

  let parentList: ModelConversationDetailMessage[] = [];
  for (let i = totalList.length - 1; i >= 0; i--) {
    const lastMessage = totalList[i];
    parentList = findParentMessage(totalList, [], lastMessage.id);
    let isFindMessage = false;
    parentList.forEach(ep => {
      if (ep.id === messageVersion!.id) {
        isFindMessage = true
      }
    });
    if (isFindMessage) {
      break;
    }
  }

  resultList = parentList.reverse();

  console.log('handleVersionConversationMessageList', resultList, totalList, message, versionIndex);

  return resultList
};

export const detectJSONStart = (buffer: string) => {
  // Check if it has markdown json format (```json)
  const hasMarkdownJson = /```(?:json)?\s*/g.test(buffer);
  
  // Check if it starts with { or [ directly (plain JSON)
  const trimmed = buffer.trim();
  const startsWithJson = /^[\{\[]/.test(trimmed);
  
  // isJsonFormat is true if either markdown format or plain JSON format
  const isJsonFormat = hasMarkdownJson || startsWithJson;
  
  const cleaned = buffer.replace(/```(?:json)?\s*/g, '');

  const jsonPattern = /(\{[\s\n]*["\w\][]|\{[\s\n]*\}|\[[\s\n]*["\w\[\]{]|\[[\s\n]*\])/;
  
  const match = cleaned.match(jsonPattern);
  return {
    isJsonFormat,
    startIndex: match ? match.index : null
  };
}